import React from 'react';
import { useLocalization } from '../contexts/LocalizationContext';

export function Footer() {
  const { t } = useLocalization();

  return (
    <footer className="bg-gray-800/50 border-t border-gray-700/50 mt-auto backdrop-blur-sm">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Left side - Branding */}
          <div className="text-center md:text-left">
            <p className="text-gray-300 text-sm">
              Built by <span className="text-white font-medium">Alex Harasic</span>
            </p>
            <p className="text-xs text-gray-500 mt-1">
              Find where to watch across 65+ countries
            </p>
          </div>

          {/* Right side - Contact & Links */}
          <div className="flex items-center gap-6 text-sm">
            <a 
              href="mailto:hello@cornpop.tv" 
              className="text-gray-400 hover:text-palette-1 transition-colors flex items-center gap-2"
            >
              <span>📧</span>
              hello@cornpop.tv
            </a>
            <div className="text-gray-500">
              © 2025 Cornpop.tv
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}